export default "__VITE_ASSET__DOvfuDQA__"